import React, { useState, useRef, useEffect } from "react";
import cx from "classnames";
import { PhoneInput } from "react-international-phone";
import "react-international-phone/style.css";
import s from "./inputPhone.scss";

const InputPhone = (props) => {
  const { className, name, label, errors, required, disabled, value } = props;

  const onChange = (val) => {
    props.onChange?.({ [name]: val });
  };

  return (
    <div
      className={cx(className, s.inputContainer, {
        withErrors: errors,
        [s.withErrors]: errors,
        [s.required]: required,
      })}
    >
      {label && (
        <div className={s.wrapLabel}>
          <label className={s.label}>{label}</label>
        </div>
      )}

      <PhoneInput defaultCountry="it" value={props.value} onChange={onChange} />
      {errors && <div className={s.errorMsg}>{errors}</div>}
    </div>
  );
};

export default InputPhone;
